<template>
  <div class="modal-mask-product" @click.self="close">
    <div class="modal-container-product form-card">
      <div class="form-card__header">
        <h2 class="form-card__title">
          <i class="bi bi-plus-square"></i>
          Ingresá el artículo
        </h2>
        <button type="button" class="modal-close" @click="close" aria-label="Cerrar">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="form-card__body">
        <div class="form-card__field">
          <label class="form-card__label">Descripción</label>
          <input type="text" v-model="product.name" class="form-control" placeholder="Ej: Servicio de envío"/>
        </div>
        <div class="form-card__field">
          <label class="form-card__label">Precio</label>
          <input type="number" v-model="product.price" min="0" step="0.01" class="form-control" placeholder="$ 0,00"/>
        </div>
        <div class="form-card__field">
          <label class="form-card__label">Tipo de IVA</label>
          <select name="iva" v-model="product.taxtype" class="form-control">
            <option value="0">SIN IVA</option>
            <option value="2.5">IVA 2.5%</option>
            <option value="5">IVA 5%</option>
            <option value="10.5">IVA 10,5%</option>
            <option value="21">IVA 21%</option>
            <option value="18">IVA 27%</option>
          </select>
        </div>
      </div>

      <div class="form-card__footer">
        <button type="button" class="form-card__btn" @click="close">Cancelar</button>
        <button type="submit" class="form-card__btn form-card__btn--primary" :disabled="!canSubmit" @click="sendProducts">
          <i class="bi bi-plus-lg"></i>
          Agregar producto
        </button>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        data() {
            return{
                product: {
                    name: '',
                    price: 0,
                    taxtype: 21,
                }
            }
        },
        computed: {
            canSubmit() {
                return this.product.name.trim().length > 0 && Number(this.product.price) > 0;
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            sendProducts() {
                var newitem = {
                    quantity: 1, 
                    id: 0,
                    price: this.product.price, 
                    bkprice: this.product.price, 
                    name: this.product.name, 
                    includetax: 1,
                    taxtype: this.product.taxtype,
                    type: "LABEL",
                    unit: "U",
                    gross: this.product.price / (1+(this.product.taxtype/100)),
                    tax: (this.product.price / (1+(this.product.taxtype/100))) * this.product.taxtype/100,
                    barcode: null,
                    code: null,
                    promorules: [],
                    stock:0,
                };

                this.$emit('sendProduct', newitem);
            }
        }
        
    }
</script>
<style lang="scss">
.modal-mask-product {
  position: fixed;
  z-index: 9999;
  inset: 0;
  background-color: rgba(16, 24, 40, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  transition: opacity 0.3s ease;
}

.modal-container-product {
  width: 100%;
  max-width: 480px;
  max-height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
  margin: 0;
  background-color: var(--surface);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);

  .form-card__body {
    overflow-y: auto;
  }
}

.modal-close {
  background: transparent;
  border: 0;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: var(--text-muted);
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover,
  &:focus {
    background: var(--surface-muted);
    color: var(--text);
    outline: none;
  }
}
</style>